<template>
    <div class="dashboard-balance mainArea top20">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <label>{{ $t("message.accountBalanceCustomerMessage") }}</label>

            <div class="panel panel-primary top10" v-if="balanceInformationLoaded">
                <div class="panel-body">
                    <div class="row top10">
                        <div class="col-lg-4 col-md-4 col-sm-6 top10">
                            <label class="controlLabel">{{ $t("message.approxDollarsRemaining") }}: </label>
                            <label>{{ handleNegativeNumber($n(balanceInformation.ApproxDollarsRemaining, 'currency')) }}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 top10">
                            <label class="controlLabel">{{ $t("message.deferredBalance") }}: </label>
                            <label>{{ $n(balanceInformation.DeferredBalance, 'currency') }}</label>
                        </div>
                        <div class="col-lg-4 col-md-4 col-sm-6 top10">
                            <label class="controlLabel">{{ $t("message.approxDaysRemaining") }}</label>
                            <label>{{ balanceInformation.ApproxDaysRemaining }}</label>
                        </div>
                    </div>
                    <div class="row top10" v-if="showAvgDailyDollarConsumption">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <label class="controlLabel">{{ $t("message.avgDailyDollarConsumption") }}</label>
                            <label>{{ handleNegativeNumber($n(balanceInformation.AverageDailyDollarConsumption, 'currency')) }}</label>
                        </div>
                    </div>
                    <div class="row top10">
                        <div class="col-lg-12 col-md-12 col-sm-12 text-center">
                            <div class="div-inline-block" :title="getTooltipMessage" v-show="balanceInformation.ShowTransferBtn"> <!-- this div is just a placeholder to display tooltip for transfer button -->
                                <button id="btnTransfer" class="btn btn-primary" :title="getTooltipMessage"
                                    @click.prevent="btnTransferClick(balanceInformation.DropDownTitle, balanceInformation.AccountBalanceID, balanceInformation.ApproxDollarsRemaining)">
                                    {{ $t("message.transfer") }}</button>
                            </div>
                        </div>
                    </div>                  
                                        
                    <div class="col-lg-3 hide">
                        <label class="controlLabel">{{ $t("message.accountBalance") }}</label>
                        <label>{{ balanceInformation.AccountBalance }}</label>
                    </div>
                </div>
            </div>      
        </div> 

        <modal v-show="isModalVisible" @close="closeModal">
            <h4 class="modal-title" slot="header">{{ $t("message.coverDeferredBalance") }}</h4>
            <div slot="body">
                <div class="col-lg-12 top10">
                    <label>{{ $t("message.transferDeferredMessage", { maxFunds: maxAvailableFunds }) }}</label>
                </div>

                <div class="col-lg-12 top10 form-group hide">
                    <div class="input-group">
                        <label id="lblAccount" v-text="account" />
                    </div>
                </div>

                <div class="col-lg-12 top10 form-group">
                    <div class="input-group">
                        <label for="txtDeferredBalanceToTransfer">{{ $t("message.transferAmount") }}</label><br />
                        <vue-numeric currency="$" separator="," v-model="deferredBalanceToTransfer" :minus="false" :precision="2" 
                                        class="form-control form-control-custom"></vue-numeric>
                    </div>
                </div>

                <div class="col-lg-12 top10 form-group">
                    <label class="text-danger" v-show="isTransferDeferredButtonDisabled">{{ $t("message.transferAmountTooMuch") }}</label>
                </div>
            </div>
            <div slot="footer">
                <button id="btnTransferDeferredBalance" class="btn btn-sm btn-primary" :disabled="isTransferDeferredButtonDisabled" 
                                                        @click.prevent="btnTransferDeferredBalanceClick()">{{ $t("message.ok") }}</button>
                <button id="btnCancel" class="btn btn-sm btn-primary" @click.prevent="closeModal()">{{ $t("message.cancel") }}</button>
            </div>
        </modal>      
    </div>
</template>

<script>
import axios from "axios";
import Modal from '@/components/common/Modal';
import VueNumeric from 'vue-numeric';
import commonJs from '@/common.js';

export default {
    name: 'Balance',
    components: {
        Modal,
        VueNumeric
    },
    data() {
        return {
            balanceInformation: {
                ApproxDollarsRemaining: 0,
                ApproxDaysRemaining: 0,
                DeferredBalance: 0,
                AccountBalance: 0,
                AverageDailyDollarConsumption: 0,
                MeterID: -1,
                PendingTransferCount: 0,
                ShowTransferBtn: false,
                AccountNumber: '',
                AccountBalanceID: -1
            },
            balanceInformationLoaded: false,
            isModalVisible: false,
            modalMessage: '',
            deferredBalanceToTransfer: 0,
            account: '',
            accountBalanceId: -1,
            maxAvailableFunds: 0,
            tooltipMessage: '',
            showAvgDailyDollarConsumption: true
        }
    },
    mounted() {
        this.getBalanceInformation();
    },
    methods: {
        showMessage(message, type) {
            this.$toasted.show(message, {type: type, position: 'top-center', duration: '4000'});
            this.$announcer.set(message);
        },
        getBalanceInformation() {
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Balance/GetBalanceInformation?date=" + new Date().getTime()
            }).then(result => {
                var response = result.data;
                if (response !== '') {
                    this.balanceInformation = response;
                    this.balanceInformationLoaded = true;

                    this.showAvgDailyDollarConsumption = this.balanceInformation.DropDownTitle.toLowerCase().indexOf("pool") === -1;
                }
            }, error => {
                console.log(error);
            });
        },
        btnTransferClick(accountInfo, accountBalanceId, approxDollarsRemaining) {
            this.deferredBalanceToTransfer = approxDollarsRemaining;
            this.account = accountInfo;
            this.accountBalanceId = accountBalanceId;
            this.maxAvailableFunds = approxDollarsRemaining;

            this.isModalVisible = true;
        },
        closeModal() {
            this.isModalVisible = false;
        },
        btnTransferDeferredBalanceClick() {
            axios({
                method: "POST",
                url: this.$httpAxiosBaseUrl() + "Balance/TransferDeferredBalance",
                data: {
                    accountBalanceId: this.accountBalanceId,
                    deferredBalanceToTransfer: this.deferredBalanceToTransfer
                }
            }).then(result => {
                var response = result.data;
                if (response !== '') {
                    this.showMessage(response.Message, response.Type);

                    if (response.Type === "success") {
                        this.isModalVisible = false;
                        this.getBalanceInformation();
                        // Fetch latest billing summary data so we can display the latest information in the header
                        this.getLatestBillingSummaryData();
                    }                    
                }
            }, error => {
                console.log(error);
            });
        },
        handleNegativeNumber(num) {
            return commonJs.reformatNumber(num);
        },
        getLatestBillingSummaryData() {
            axios({
                method: "GET",
                url: this.$httpAxiosBaseUrl() + "Home/GetBillingSummary?date=" + new Date().getTime()
            }).then(result => {
                var response = result.data;
                if (response !== '') {
                    this.$store.commit('setBillingSummaryData', response);
                }
            }, error => {
                console.log(error);
            });
        }
    },
    computed: {
        isTransferDeferredButtonDisabled() {
            return this.deferredBalanceToTransfer > this.maxAvailableFunds || this.deferredBalanceToTransfer < 0;
        },
        getTooltipMessage() {
            if (this.balanceInformationLoaded) {
                // Once our balance information is loaded, let's check if we need to display Transfer button or not?
                if (this.balanceInformation.ShowTransferBtn) {
                    this.tooltipMessage = "";
                } else {
                    this.tooltipMessage = "There is no deferred balance to transfer to.";
                }
                return this.tooltipMessage;
            }
            return this.tooltipMessage = "";
        }
    }
}
</script>

<style scoped>
.form-control-custom {
    width: 200px;
    border-radius: 0;
    margin-left: 2px;
}  

.btn-disabled {
    cursor: not-allowed;
    pointer-events: none;
}

    .btn-disabled:hover {
        background-color: #CC0000 !important;
        border-color: #CC0000 !important;
    }
</style>
